import React from 'react';
import clsx from 'classnames';
import './index.css';
import TweenOne from 'rc-tween-one';

const Banner = () => {
  const onContact = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth',
    });
  };

  return (
    <div className={clsx('business-banner')}>
      <div className={clsx('business-banner-mask')} />
      <div className={clsx('business-banner-content')}>
        <TweenOne
          className={clsx('business-banner-title')}
          animation={{ y: 30, opacity: 0, type: 'from' }}
        >
          优质服务，高效专业
        </TweenOne>
        <TweenOne
          className={clsx('business-banner-text')}
          animation={{ y: 40, opacity: 0, type: 'from', delay: 100 }}
        >
          High-quality service, efficient and professional
        </TweenOne>
        <TweenOne
          className={clsx('business-banner-button')}
          onClick={onContact}
          animation={{ y: 50, opacity: 0, type: 'from', delay: 200 }}
        >
          联系我们
        </TweenOne>
      </div>
    </div>
  );
};

export default Banner;
